import { inject } from '@angular/core';
import { AppStateFacade } from '../../app-state/app.facade';
import { ERROR_PAGE_DATA_DEFAULTS, errorToErrorPageData } from '../../error';
import { FeatureRouterLinkResolverService } from '../../feature';
import { CustomRouter } from './router.class';
import { NavigationError, RedirectCommand } from '@angular/router';
export function routerErrorHandler(error) {
  const router = inject(CustomRouter);
  console.log('routerErrorHandler was called', error);
  let errorPageData = error instanceof NavigationError ? parseRouterError(error) : errorToErrorPageData(error, ERROR_PAGE_DATA_DEFAULTS.ERR_ROUTER);
  if (errorPageData.message.includes('JIT compilation')) {
    errorPageData.message = "Die JIT Kompilierung ist fehlgeschlagen. Mehr Informationen sind in der Konsole zu finden.";
  }
  if (errorPageData.errorName === 'ChunkLoadError') {
    inject(AppStateFacade).setChunkError();
  }
  const routerLinkResolver = inject(FeatureRouterLinkResolverService);
  const link = routerLinkResolver.resolveRouterLink('error-router');
  if (link) {
    return new RedirectCommand(router.parseUrl(link.join('/')), {
      skipLocationChange: false,
      state: errorPageData
    });
  } else {
    if (!IS_PRODUCTION) console.log('no routerLinkResolver for "error-router" has been set. Aborting navigation to error page.');
  }
}
function parseRouterError(navError) {
  const error = navError.error;
  const errorData = {
    summary: "Navigationsfehler",
    message: null,
    errorName: "NavigationError",
    status: null
  };
  // runtime error code docs: https://github.com/angular/angular/blob/main/goldens/public-api/router/errors.api.md#L30
  switch (error.code) {
    case 4002:
      errorData.message = "Die aufgerufene Seite existiert nicht.";
      errorData.status = 404;
      break;
    default:
      errorData.message = "Die Seite konnte nicht geladen werden. Fehlercode: " + error.code;
      break;
  }
  return errorData;
}